import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/team.jpg";
import Card6 from "../Images/Profiles/Juliet.jpg";
import "../Profiles/Profile.css"; // Using the common Profile CSS
import Breadcrumb from "react-bootstrap/Breadcrumb";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import XIcon from "@mui/icons-material/X"; // Standardized X icon
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import EmailIcon from "@mui/icons-material/Email";
import "../Pages/NewsandEvents.css"; // ← reuse styles for hero and breadcrumb

function JulietKyayesimira() {
  return (
    <div className="ne-page">
      <SEO
        title="Dr. Juliet Kyayesimira - Secretary General"
        description="Dr. Juliet Kyayesimira is the Secretary General at CIRCODU with a PhD in Biology and a Master's degree in Biology."
        keywords="Juliet Kyayesimira, Secretary General, CIRCODU, PhD in Biology, Master's degree in Biology"
        url="/juliet-kyayesimira"
        image={Card6}
        type="profile"
      />

      {/* ── Hero banner ─────────────────────────────── */}
      <div className="ne-hero">
        <div className="ne-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="ne-hero__overlay">
          <h4 className="ne-hero__title">Dr. Juliet Kyayesimira</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">The Team</Breadcrumb.Item>
            <Breadcrumb.Item className="text1" href="/the-team/top-management">
              Top Management
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              Dr. Juliet Kyayesimira
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      {/* ── Profile section ─────────────────────────── */}
      <section className="profile-section border-bottom">
        <div className="container">
          <div className="profile-card">
            {/* Green banner strip */}
            <div className="profile-card__banner" />

            {/* Photo + name/role */}
            <div className="profile-card__header">
              <div className="profile-card__photo-wrap">
                <img src={Card6} alt="Dr. Juliet Kyayesimira" />
              </div>
              <div className="profile-card__identity">
                <h1 className="profile-card__name">Dr. Juliet Kyayesimira</h1>
                <p className="profile-card__role">Secretary General</p>
                <p className="profile-card__specialty">
                  Natural Resources Conservation Specialist
                </p>
              </div>
            </div>

            {/* Accent divider */}
            <div className="profile-card__divider" />

            {/* Biography */}
            <div className="profile-card__body">
              <div className="texty">
                <p>
                  Juliet holds the position of Secretary General at the Center
                  for Integrated Research and Community Development Uganda
                  (CIRCODU), where she serves as a Director and Researcher.
                </p>
                <p>
                  Her academic background includes a Doctor of Philosophy (PhD
                  in Biology), focusing on post-harvest losses and microbial
                  conditions of beef within Uganda's meat value chain.
                  Complementing this, she possesses a Master of Science in
                  Biology (with a specialization in Natural Resources, Ecology &
                  Conservation) and a Bachelor's degree in Science with
                  Education from Mbarara University of Science and Technology.
                </p>
                <p>
                  Dr. Juliet's professional engagement encompasses various
                  activities such as teaching, overseeing graduate and
                  undergraduate research, and contributing to curriculum design.
                  Her research interests span across natural resource
                  conservation, climate change, energy, botany, and food safety.
                </p>
                <p>
                  With over 16 years of dedicated service at CIRCODU, Juliet
                  brings a wealth of expertise in developmental activities,
                  implementation, and oversight. Her contributions have been
                  notably impactful, encompassing extensive community
                  development and outreach initiatives.
                </p>
                <p>
                  She possesses substantial expertise in tool development,
                  executing interviews and surveys, facilitating Focus Group
                  Discussions, conducting Kitchen Performance Tests, as well as
                  carrying out laboratory and field evaluations related to clean
                  cookstoves and fuels.
                </p>
              </div>
            </div>

            {/* Social links */}
            <div className="profile-card__socials">
              <a
                href="https://www.linkedin.com/in/dr-juliet-kyayesimira-37488587/"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--linkedin"
                aria-label="LinkedIn"
              >
                <LinkedInIcon />
                <span>LinkedIn</span>
              </a>

              <a
                href="https://twitter.com/Jkyayesimira"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--twitter"
                aria-label="X / Twitter"
              >
                <XIcon />
                <span>Twitter / X</span>
              </a>

              <a
                href="https://www.facebook.com/juliet.kyayesimira/"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--facebook"
                aria-label="Facebook"
              >
                <FacebookOutlinedIcon />
                <span>Facebook</span>
              </a>

              <a
                href="https://wa.me/256702557243"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-card__social-btn profile-card__social-btn--whatsapp"
                aria-label="WhatsApp"
              >
                <WhatsAppIcon />
                <span>WhatsApp</span>
              </a>

              <a
                href="mailto:kyayesimira@circodu.org.ug"
                className="profile-card__social-btn profile-card__social-btn--email"
                aria-label="Email"
              >
                <EmailIcon />
                <span>Email</span>
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default JulietKyayesimira;
